(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-form"]) return;
  try {
    
$( document ).ready(function() {
  $("#form-design[name='btype']").click(function(){
   // $("#contact-form iframe").attr("src", $(this).data("url"));
	$("#contact-design").css("display","block");
	$("#contact-rental").css("display","none");
});
$("#form-rental[name='btype']").click(function(){
   //$("#contact-form iframe").attr("src", $(this).data("url"));
	$("#contact-design").css("display","none");
	$("#contact-rental").css("display","block");
});
//scroll to forms
var pad = '70';
 $(".smooth-scroll").click(function(e) {
	e.preventDefault()
    $('html, body').animate({
        scrollTop: $("#application").offset().top - pad
    }, 700);
});
});

$(document).ready(function() {
//thank you message
if (window.location.search.indexOf('complete') > -1) {
console.log('thankyou');
// Parse the URL parameter
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
// Give the parameter a variable name
var dynamicContent = getParameterByName('complete');
	$('#tradeforms').hide();
	$('#thankyou').show();
	
	// Check if the URL parameter design
	if (dynamicContent == 'design') {
	$('#thankyou').html('<p>Thank you for your interest. We will review your application and get back to you within 1 business day.</p>');
	} 
	// Check if the URL parameter is rental
	else if (dynamicContent == 'rental') {
		$('#thankyou').html('<p>Thank you for your interest. Your discount code will be mailed to you shortly.</p><p>If you are interested in placing an order over $2,000, please reach out to us at: support@standardtextilehome.com.</p>');
	} 
	else {
		$('#tradeforms').show();
		$('#thankyou').hide();
	}
}
});

  } catch(e) { console.error(e); }
})();
})();
